import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import UserForm from '../components/users/UserForm';
import { useDispatch } from 'react-redux';
import { createUser } from '../store/slices/usersSlice';

const UserCreate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCreateUser = async (userData) => {
    try {
      await dispatch(createUser(userData)).unwrap();
      navigate('/users');
    } catch (error) {
      console.error('Failed to create user:', error);
    }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate('/users')}
          sx={{ mr: 2 }}
        >
          Back to Users
        </Button>
        <Typography variant="h4">
          Create New User
        </Typography>
      </Box>

      <UserForm
        open={true}
        onClose={() => navigate('/users')}
        onSubmit={handleCreateUser}
        title="Create New User"
      />
    </Box>
  );
};

export default UserCreate;